import interact from 'interactjs';

export const linkInteractable = interact(
	'[data-url], .post--audio, .post--video, .glossaryTerm, .element--button'
);

linkInteractable.on('down', event => {
	event.currentTarget.classList.add('active');
});

linkInteractable.on('move', event => {
	event.currentTarget.classList.remove('active');
});

linkInteractable.on('tap', event => {
	// event.stopPropagation();
	const element = event.currentTarget;

	// the 'up' event removes the active class before tap is fired
	event.currentTarget.classList.add('active');

	setTimeout(() => {
		element.classList.remove('active');
	}, 2000);
});

// remove active class when pointer goes up that went down on a link
interact(document.documentElement).on('up cancel', event => {
	const { downTarget } = event._interaction.pointers[0];
	const link =
		downTarget &&
		downTarget.closest(
			'[data-url].active, .post--audio.active, .post--video.active, .glossaryTerm.active, .element--button.active'
		);

	if (link) {
		link.classList.remove('active');
	}
});
